import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import "./header.css"
import { ExistIcon, SettingIcon } from 'components/icon'
import { Button, MultiButton } from 'components/button';
import { Flex } from 'components/flex';
import { useAuth } from 'AuthProvider';
import { alert, callApi } from 'utils';
import axios from "axios";
import logo from "assets/images/logo.svg"

import * as ChannelService from '@channel.io/channel-web-sdk-loader';

const getMemberHash = async () => {
  const postData = {
    opId: sessionStorage.getItem("userId"),
    opeNo: sessionStorage.getItem("opeNo"),
    email: sessionStorage.getItem("email")
  };

  const response = await callApi('api/platform/setChannelTalkHash', postData);

  return response.data;
}

const connectionChannelTalk = async (infos) => {
  const memberHash = await getMemberHash();

  const phoneNumber = infos.phoneNumber.replace(/-/g,"").substring(1);

  ChannelService.boot({
    pluginKey: '0c633aa7-f7cb-4b99-aa69-0570db0ee45d', // fill your plugin key,
    memberId: sessionStorage.getItem("userId"),
    memberHash: memberHash,
    profile: {
      chatType: "hulampro_inquiry",
      name: infos.companyName,
      mobileNumber: `+82${phoneNumber}`,
      email: infos.emailAddress,
      loginType: sessionStorage.getItem("author") === "manager" ? "hp_company" : "hp_employee"
    }
  });

}

export default function Header({
  isLogin = false
}) {
  const mobileRef = useRef();
  const navRef = useRef();

  ChannelService.loadScript()

  const HomepageHeader = () => {
    const mobileOnOff = () => {
      mobileRef.current.classList.toggle("on");
      navRef.current.classList.toggle("on");
    }

    const mobileOff = () => {
      mobileRef.current.classList.remove("on");
      navRef.current.classList.remove("on");
    }

    ChannelService.boot({
      pluginKey: '0c633aa7-f7cb-4b99-aa69-0570db0ee45d', // fill your plugin key
      profile: {
        chatType: "hulampro_inquiry",
        loginType: "guest"
      }
    });

    return (
      <div className="inner">
        <h1 className="logo">
          <Link to="/" onClick={() => mobileOff()}><img src={logo} alt="logo" /></Link>
        </h1>
        <nav ref={navRef}>
          <ul className="menu">
            <li><Link to="/subscriptionFee" onClick={() => mobileOff()}>이용요금</Link></li>
          </ul>
          {/* <div className="service_menu">
            <Link to="/login" style={{ margin: '0 39px' }}>로그인</Link>
            <Link to="/join" className='reg_button'>
              가입하기
            </Link>
          </div> */}
          <MultiButton className={"service_menu"}>
            <Button type="text" href="/login" width={110} onClick={() => mobileOff()}>로그인</Button>
            <Button type="background-purple" href="/join" width={110} onClick={() => mobileOff()}>가입하기</Button>
          </MultiButton>
        </nav>
        <div ref={mobileRef} className="m_menu" onClick={() => mobileOnOff()}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    )
  }


  /**@function ProgramHeader
   * 로그인 O 헤더
   */
  const ProgramHeader = () => {

    const { author, logout, onBoardingClose, setOnBoardingClose, adminlogin } = useAuth();
    const [companyName, setCompanyName] = useState('');
    const [employeeName, setEmployeeName] = useState('');
    const [employeeCount, setEmployeeCount] = useState(0);


    useEffect(() => {
      const profileSetting = async () => {

        let sessionStorage = window.sessionStorage;
        let opId = sessionStorage.getItem("userId");
        let email = sessionStorage.getItem("email");

        const postData = {
          opId: opId,
          email: email
        };

        if (opId) {

          const response = await callApi('api/platform/viewPrivateSetting', postData);
          if (response && response.result) {
            const { data } = response

            setCompanyName(data.companyName ? data.companyName : '');
            setEmployeeCount(data.employeeCount ? data.employeeCount : 0);
            connectionChannelTalk(data);

          } else if (response === 402) {
            if (author !== "admin") {
              logout();
            }

          }
        }

      }

      profileSetting();
    }, [logout, author])

    useEffect(() => {
      const getEmployeeInfo = async () => {
        let sessionStorage = window.sessionStorage;
        const postData = {
          opId: sessionStorage.getItem("userId"),
          opeNo: sessionStorage.getItem("opeNo"),
          email: sessionStorage.getItem("email")
        };

        const response = await callApi('api/platform/viewPrivateSetting', postData);

        if (response && response.result) {
          setEmployeeName(response.data.employeeName)
        }
      }

      if (author === "employee") {
        getEmployeeInfo();
      }
    }, [author])

    let sessionStorage = window.sessionStorage;
    let adminId = sessionStorage.getItem("adminId");
    let userId = sessionStorage.getItem("userId");
    let adminAccessToken = sessionStorage.getItem("adminAccessToken");



    return <header id="header" className="App-header header shadow">
      <div className="inner authheader ">
        <div className="h_left">
          <div className="header_info" style={{ display: "flex", alignItems: "center" }}>
            <em>{companyName}</em>
            {
              author === "manager" && (
                <>
                  <span>|</span>
                  <Flex  >
                    <span className="worker_num">직원수 {employeeCount}명</span>
                  </Flex>
                </>
              )
            }
            {
              author === "employee" && (
                <>
                  <span>|</span>
                  <Flex  >
                    <span className="worker_num">{employeeName}</span>
                  </Flex>
                </>
              )
            }

          </div>
          {window.location.hostname.includes('dev.hulampro.co.kr') || window.location.hostname.includes('localhost') ? <div className="info_box" style={{ padding: "8px 16px", height: 30, marginLeft: 14 }}>
            <i className="svg_icon_20_warning"></i>
            <span style={{ color: "#52545C", fontSize: 14, lineHeight: 14 }}>개발 서버</span>
          </div> : null}

        </div>
        <div className="h_right">
          <Flex columnGap={20}>
            {userId !== "hulampro_admin" && adminId === "hulampro_admin" && adminAccessToken ?
              <Button
                type="line-gray"
                size="sm"
                style={{ columnGap: 10 }}
                onClick={() => {
                  axios.get('https://geolocation-db.com/json/').then(async (res) => {
                    let sessionStorage = window.sessionStorage;
                    let adminId = sessionStorage.getItem("adminId");
                    let adminAccessToken = sessionStorage.getItem("adminAccessToken");

                    let response = {
                      type: "admin",
                      userId: adminId
                      , access_token: adminAccessToken,
                      adminId, adminAccessToken

                    };

                    const postData = {
                      opId: adminId,
                      userId: adminId,
                      ip: res.data.IPv4
                      // 추가 필드
                    };
                    console.log(postData);

                    await callApi('api/admin/loginInfo', postData);
                    adminlogin(response);
                  }
                  );
                }}
              >
                어드민 로그인
              </Button>
              : null}
            {

              (onBoardingClose && author === "manager") && (
                <Button
                  type="line-gray"
                  size="sm"
                  style={{ columnGap: 10 }}
                  onClick={() => setOnBoardingClose(false)}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M4.70542 2.5L5.06467 2.5C5.91129 2.5 6.58222 2.49999 7.12301 2.54384C7.67603 2.58867 8.14395 2.68222 8.57122 2.89825C9.15609 3.19396 9.64865 3.63837 10.0003 4.18327C10.352 3.63837 10.8446 3.19396 11.4294 2.89825C11.8567 2.68222 12.3246 2.58867 12.8776 2.54384C13.4184 2.49999 14.0894 2.5 14.936 2.5L15.2952 2.5C15.7093 2.49999 16.0549 2.49999 16.3373 2.52288C16.6318 2.54675 16.9082 2.59838 17.1697 2.73056C17.5708 2.93337 17.8969 3.25699 18.1013 3.65502C18.2345 3.91445 18.2865 4.1888 18.3106 4.48102C18.3337 4.7612 18.3337 5.10416 18.3337 5.51504V12.1773C18.3337 12.5882 18.3337 12.9311 18.3106 13.2113C18.2865 13.5035 18.2345 13.7779 18.1013 14.0373C17.8969 14.4353 17.5708 14.7589 17.1697 14.9617C16.9082 15.0939 16.6318 15.1456 16.3373 15.1694C16.0549 15.1923 15.7093 15.1923 15.2952 15.1923H14.2059C13.1989 15.1923 12.8166 15.1982 12.4781 15.3002C12.1612 15.3957 11.8664 15.5523 11.6105 15.7609C11.3372 15.9838 11.1202 16.2962 10.5616 17.1276L10.4841 17.2431C10.3762 17.4036 10.1947 17.5 10.0003 17.5C9.80593 17.5 9.62441 17.4036 9.51658 17.2431L9.43901 17.1276C8.88045 16.2962 8.66344 15.9838 8.39016 15.7609C8.13429 15.5523 7.83946 15.3957 7.52255 15.3002C7.18407 15.1982 6.80173 15.1923 5.79476 15.1923H4.7054C4.29133 15.1923 3.94572 15.1923 3.66337 15.1694C3.36889 15.1456 3.09241 15.0939 2.83097 14.9617C2.42985 14.7589 2.10372 14.4353 1.89934 14.0373C1.76613 13.7779 1.71411 13.5035 1.69005 13.2113C1.66698 12.9311 1.66698 12.5881 1.66699 12.1773V5.51505C1.66698 5.10416 1.66698 4.7612 1.69005 4.48102C1.71411 4.1888 1.76613 3.91445 1.89934 3.65502C2.10372 3.25699 2.42985 2.93337 2.83097 2.73056C3.09241 2.59838 3.36889 2.54675 3.66337 2.52288C3.94572 2.49999 4.29134 2.49999 4.70542 2.5ZM9.41893 8C9.41893 7.12886 9.41848 6.5102 9.37862 6.02606C9.33931 5.54866 9.2646 5.25308 9.14433 5.01887C8.90279 4.54847 8.51738 4.16601 8.04333 3.92633C7.8073 3.80699 7.50943 3.73286 7.02833 3.69385C6.54043 3.6543 5.91698 3.65385 5.03909 3.65385H4.72901C4.28527 3.65385 3.98742 3.6543 3.75806 3.67289C3.53548 3.69094 3.42906 3.72315 3.35886 3.75865C3.17653 3.85083 3.0283 3.99793 2.9354 4.17886C2.89963 4.24852 2.86716 4.35412 2.84898 4.57498C2.83024 4.80258 2.82978 5.09813 2.82978 5.53846V12.1538C2.82978 12.5942 2.83024 12.8897 2.84898 13.1173C2.86716 13.3382 2.89963 13.4438 2.9354 13.5135C3.0283 13.6944 3.17653 13.8415 3.35886 13.9337C3.42906 13.9692 3.53548 14.0014 3.75806 14.0194C3.98742 14.038 4.28527 14.0385 4.72901 14.0385H5.79476C5.82648 14.0385 5.8578 14.0385 5.88873 14.0384C6.76921 14.0383 7.33616 14.0381 7.86044 14.1961C8.32362 14.3357 8.75452 14.5645 9.12848 14.8695C9.23029 14.9526 9.32579 15.0427 9.41893 15.1419V8ZM10.5817 15.1419C10.6749 15.0427 10.7704 14.9526 10.8722 14.8695C11.2461 14.5645 11.677 14.3357 12.1402 14.1961C12.6645 14.0381 13.2314 14.0383 14.1119 14.0384C14.1429 14.0385 14.1742 14.0385 14.2059 14.0385H15.2716C15.7154 14.0385 16.0132 14.038 16.2426 14.0194C16.4652 14.0014 16.5716 13.9692 16.6418 13.9337C16.8241 13.8415 16.9724 13.6944 17.0653 13.5135C17.101 13.4438 17.1335 13.3382 17.1517 13.1173C17.1704 12.8897 17.1709 12.5942 17.1709 12.1538V5.53846C17.1709 5.09813 17.1704 4.80258 17.1517 4.57498C17.1335 4.35412 17.101 4.24852 17.0653 4.17886C16.9724 3.99793 16.8241 3.85083 16.6418 3.75865C16.5716 3.72315 16.4652 3.69094 16.2426 3.67289C16.0132 3.6543 15.7154 3.65385 15.2716 3.65385H14.9616C14.0837 3.65385 13.4602 3.6543 12.9723 3.69385C12.4912 3.73286 12.1934 3.80699 11.9573 3.92633C11.4833 4.16601 11.0979 4.54847 10.8563 5.01887C10.7361 5.25308 10.6613 5.54866 10.622 6.02606C10.5822 6.5102 10.5817 7.12886 10.5817 8V15.1419Z" fill="#1A1818" />
                  </svg>
                  노무사 플랫폼 온보딩 가이드
                </Button>
              )
            }
            {author !== "admin" ? <Link to="/hulamSetting">
              <SettingIcon />
            </Link> : null}

            <Button type="text" onClick={() => {
              alert({
                type: "confirm",
                icon: true,
                content: "로그아웃 하시겠습니까?",
                okText: "로그아웃하기",
                okButtonWidth: 100,
                onOk: logout
              })
            }}>
              <ExistIcon />
            </Button>
          </Flex>
        </div>
      </div>
    </header>
  }

  return (
    <>
      {
        isLogin ?
          <ProgramHeader /> :
          <header>
            <HomepageHeader />
          </header>
      }


    </>
  )
}
